"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var Sync = function Sync(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2["default"])({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("defs", null, (0, _core.jsx)("path", {
    d: "M18.511 15.627a.311.311 0 01-.512 0l-2.184-3.117a.321.321 0 01.256-.507h1.558a5.626 5.626 0 00-9.177-4.36.625.625 0 01-.809-.952 6.876 6.876 0 0111.236 5.312h1.56a.321.321 0 01.256.507l-2.184 3.117zM6.007 8.386l2.184 3.117a.321.321 0 01-.256.507H6.378a5.626 5.626 0 009.177 4.36.625.625 0 11.809.953A6.876 6.876 0 015.128 12.01h-1.56a.321.321 0 01-.257-.507l2.184-3.117a.311.311 0 01.512 0z",
    id: "Sync_svg__a"
  })), (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("mask", {
    id: "Sync_svg__b",
    fill: "#fff"
  }, (0, _core.jsx)("use", {
    xlinkHref: "#Sync_svg__a"
  })), (0, _core.jsx)("g", {
    mask: "url(#Sync_svg__b)",
    fill: "currentColor"
  }, (0, _core.jsx)("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var _default = (0, _react.forwardRef)(Sync);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Sync, "Sync", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Sync.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Sync.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();